/* eslint-disable @typescript-eslint/naming-convention */

import { Trigger, AbsenceItem } from './';

export class ScheduleItem {
    Id?: number;
    StartDate: Date;
    EndDate?: Date;
    Enabled = false;

    Triggers: Trigger[] = [];
    AbsenceItems: AbsenceItem[] = [];
}
